import angular from 'angular';
import ConfigsModule from '../../../configs/configs';
import ResourcesModule from '../../../resources/resources';
import ServicesModule from '../../../services/services';
import FieldConfigsTransform from './fieldConfigsTransform';
import template from './gamesEdit.jade';

export class GamesEditController {
  /* @ngInject */
  constructor($stateParams,GamesResource,CampaignsResource,$state,$auth,Upload,notify) {
    this.GamesResource = GamesResource;
    this.CampaignsResource = CampaignsResource;
    this.$state = $state;
    this.$auth = $auth;
    this.Upload = Upload;
    this.notify = notify;
    this.isResourceBeingPersisted = false;

    if ($stateParams.id) {
      this.getResource($stateParams.id);
    } else {
      this.new = true;
      this.resource = {};
      this.variations = [];
      this.getFieldConfigs({});
    }
  }

  getResource(id) {
    this.GamesResource.one(id).get().then((res) => {
      this.resource = res;
      this.getFieldConfigs(res);
      this.CampaignsResource.getList({game_id: id})
          .then((res) => {
              this.resource.campaigns = res;
          });
    });
  }

  getFieldConfigs(game) {
    this.simplaexFieldConfigs = FieldConfigsTransform.deserialize(game.simplaex_field_configs);
    this.simplaexFieldConfigs.forEach((fieldConfig) => fieldConfig.disabled = true);
    this.customFieldConfigs = FieldConfigsTransform.deserialize(game.custom_field_configs);
  }

  addField() {
    let newFieldConfig = _.findLast(this.simplaexFieldConfigs, {field_name: this.newFieldName }) || {};
    this.customFieldConfigs.push(newFieldConfig);
    this.editFieldConfig(newFieldConfig);
    this.newFieldName = '';
  }

  removeField(fieldConfig) {
    _.remove(this.customFieldConfigs, fieldConfig);
  }

  editFieldConfig(fieldConfig) {
    _.without(this.customFieldConfigs, fieldConfig).forEach(fieldConfig => fieldConfig.editing = false);
    fieldConfig.editing = !fieldConfig.editing;
  }

  refreshDynamicFields() {
    if (this.resource.id) {
      this.isResourceBeingPersisted = true;
      this.GamesResource.one(this.resource.id).one('refresh').get().then((res) => {
        this.notify.success('updatedDynamicFields');
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
    }
  }

  toggleEditJson() {
    this.editJson = !this.editJson;
    if (this.editJson) {
      this.resource.custom_field_configs = FieldConfigsTransform.serialize(this.customFieldConfigs);
      this.simplaexFieldConfigsJson = JSON.stringify(this.resource.simplaex_field_configs, undefined, 4);
      this.customFieldConfigsJson = JSON.stringify(this.resource.custom_field_configs, undefined, 4);
    }
  }

  saveJson() {
    this.resource.simplaex_field_configs = JSON.parse(this.simplaexFieldConfigsJson);
    this.resource.custom_field_configs = JSON.parse(this.customFieldConfigsJson);
    this.getFieldConfigs(this.resource);
    this.editJson = false;
  }

  save() {
    delete this.resource.campaigns;
    this.resource.custom_field_configs = FieldConfigsTransform.serialize(this.customFieldConfigs);
    this.isResourceBeingPersisted = true;
    if (this.resource.id) {
      this.update();
    } else {
      this.create();
    }
  }

  create() {
    this.GamesResource.post(this.resource)
      .then((res) => {
        this.checkAndUploadLogoFile(res.id);
        this.notify.created('app', this.resource.name);
        this.$state.go('app.admin.games.edit', {id: res.id});
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
  }

  update() {
    this.resource.save()
      .then(() => {
        this.checkAndUploadLogoFile(this.resource.id);
        this.notify.updated('app', this.resource.name);
        this.$state.go('app.admin.games.edit', {id: this.resource.id});
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
  }

  checkAndUploadLogoFile(gameId) {
    if (this.logo) {
      this.Upload.upload({
        url: `/api/v1/games/${gameId}/logo_upload`,
        headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
        data: {file: this.logo}
      }).then((res) => {
        this.resource.url = res.data.url;
        this.logo = null;
      })
    }
  }
}

export function GamesEditComponent() {
  return {
    template,
    controller: GamesEditController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.admin.games.edit', [
  'ngFileUpload',
  ConfigsModule.name,
  ResourcesModule.name,
  ServicesModule.name
])
.directive('adminGamesEdit', GamesEditComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/games/gamesEdit.js
 **/